import { Brand } from '@/components/Brand';
import { Button } from '@/components/ui/button';

export function NotOnListScreen({
  email,
  onSignOut,
  onCheckAgain,
  checking,
}: {
  email: string | undefined;
  onSignOut: () => void;
  onCheckAgain: () => void;
  checking: boolean;
}) {
  return (
    <main className="scanlines bg-hud-grid grid h-full place-items-center p-6">
      <div className="cut-tr w-full max-w-md bg-bg-2/85 p-8 shadow-[inset_0_0_0_1px_var(--color-red)]">
        <Brand size="lg" />
        <p className="hud-label mt-8">Access denied</p>
        <h1 className="mt-2 font-display text-xl font-black tracking-[0.04em] text-red uppercase">
          You&apos;re not on The Hive&apos;s studio list
        </h1>
        <p className="mt-2 text-muted">
          {email ? (
            <>
              You signed in as <code>{email}</code>.{' '}
            </>
          ) : null}
          Ask a founder to add your email to the studio list, then check again.
        </p>
        <div className="mt-6 flex gap-2">
          <Button variant="ghost" onClick={onCheckAgain} disabled={checking}>
            Check again
          </Button>
          <Button variant="danger" onClick={onSignOut}>
            Sign out
          </Button>
        </div>
      </div>
    </main>
  );
}
